<template>
    <v-card>
        <v-card-text>
            <v-col 
                class="text-center"  
                v-if="ORGANIZATION_DEBT_RESULTS_STATUS === 'DISCONNECT'"
            >
                <v-alert
                    border="left"
                    colored-border
                    color="deep-purple accent-4"
                    elevation="2"
                >
                    <p>С 1 января 2022 г. поставщики жилищно-коммунальных услуг обязаны через ГИС ЖКХ предоставлять социальным службам данные о наличии или об отсутствии 
                        подтвержденной судебным актом непогашенной задолженности по оплате ЖКУ, за период не более 3-х лет.</p>

                    <p>Подключая данный сервис вы сможете вовремя получать запросы и отправлять ответы в ГИС ЖКХ о наличии или об отсутствии 
                        вышеуказанных задолженностей одним нажатием кнопки.</p>
                </v-alert>
                <v-btn
                    color="primary"
                    :disabled="isFetchingDebtConnection"
                    class="mr-3"
                    @click="onConnectionDebtResults"
                >Подключить сервис соцзащиты</v-btn>
            </v-col>
            <v-col
                class=""  
                v-if="ORGANIZATION_DEBT_RESULTS_STATUS === 'PENDING'"
            >
                <organization-connection-action-pending-vue></organization-connection-action-pending-vue>
            </v-col>
            <v-col
                class=""  
                v-if="ORGANIZATION_DEBT_RESULTS_STATUS === 'CONNECT'"
            >
                <v-alert
                    type="info"
                >
                   Сервис успешно подключен
                </v-alert>
            </v-col>
        </v-card-text>
    </v-card>
</template>
<script>
import OrganizationConnectionActionPendingVue from './OrganizationConnectionActionPending.vue';
import * as organizationApi from '@/api/organizations';
import {mapGetters, mapActions} from 'vuex';
export default {
    name: 'OrganizationConnectionAction',
    components:{
        OrganizationConnectionActionPendingVue
    },
    data(){
        return {
            isFetchingDebtConnection: false,
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_MESSAGE', 'SHOW_ERROR', 'SHOW_SUCCESS']),
        ...mapActions('workspace', ['RELOAD_ORGANIZATION']),
        async onConnectionDebtResults(){
            try{
                this.isFetchingDebtConnection = true;
                let {data} = await organizationApi.debtResultsConnection(this.ID_WORK_SPACE, this.ORGANIZATION_ID);
                if(data.status === "SUCCESS"){
                    this.SHOW_SUCCESS(data.result.message + 
                    ". Наши специалисты свяжутся с Вами для настройки автоматической выгрузки из ГИС ЖКХ запросов соцзащиты. Ожидайте.");
                }
                if(data.status === "ERROR"){
                    this.SHOW_ERROR(data.result.error);
                }
                await this.RELOAD_ORGANIZATION();
            }catch(err){
                this.SHOW_ERROR('Ошибка добавления организации');
                console.log(err);
            }finally{
                this.isFetchingDebtConnection = false;
            }
        },
        async onConnectionDebtResultsRetry(){
            try{
                this.isFetchingDebtConnection = true;
                let {data} = await organizationApi.debtResultsConnectionRetry(this.ID_WORK_SPACE, this.ORGANIZATION_ID);
                if(data.status === "SUCCESS"){
                    this.SHOW_SUCCESS(data.result.message);
                }
                if(data.status === "ERROR"){
                    this.SHOW_ERROR(data.result.error);
                }
                await this.RELOAD_ORGANIZATION();
            }catch(err){
                this.SHOW_ERROR('Ошибка повторного запроса');
                console.log(err);
            }finally{
                this.isFetchingDebtConnection = false;
            }
        },
    },
    computed: {
        ...mapGetters( 'user', ['HAS_ROLE']),
        ...mapGetters( 'workspace', [
            'ID_WORK_SPACE', 'ORGANIZATION_ID', 'ORGANIZATION_DEBT_RESULTS_STATUS', 'ORGANIZATION_DEBT_RESULTS_CONNECTION_LAST', 
            'ORGANIZATION_DEBT_RESULTS_CONNECTION_EXCHANGE_STATUS'
        ]),
        showBtnRetry(){
            return (this.ORGANIZATION_DEBT_RESULTS_STATUS === 'PENDING') && (this.HAS_ROLE('admin') || this.HAS_ROLE('manager'));
        },
    }
}
</script>